module.exports = __webpack_public_path__ + "img/vi.vi2394a01.svg";